module.exports = __webpack_public_path__ + "img/20_113.a779132e.png";